import { render, staticRenderFns } from "./CartInfoCard.vue?vue&type=template&id=194a8d3b"
import script from "./CartInfoCard.vue?vue&type=script&lang=js"
export * from "./CartInfoCard.vue?vue&type=script&lang=js"
import style0 from "./CartInfoCard.vue?vue&type=style&index=0&id=194a8d3b&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports